__turbopack_context__.v({
  "tesimonial__background": "Sd-1Jq_tesimonial__background",
  "testemonial__image": "Sd-1Jq_testemonial__image",
  "testemonial__quote": "Sd-1Jq_testemonial__quote",
  "testimonial": "Sd-1Jq_testimonial",
  "testimonial__arrow": "Sd-1Jq_testimonial__arrow",
  "testimonial__arrow__backward": "Sd-1Jq_testimonial__arrow__backward",
  "testimonial__arrow__forward": "Sd-1Jq_testimonial__arrow__forward",
  "testimonial__arrow__hidden": "Sd-1Jq_testimonial__arrow__hidden",
  "testimonial__bio": "Sd-1Jq_testimonial__bio",
  "testimonial__dot": "Sd-1Jq_testimonial__dot",
  "testimonial__dot__active": "Sd-1Jq_testimonial__dot__active",
  "testimonial__dots": "Sd-1Jq_testimonial__dots",
  "testimonialtrack": "Sd-1Jq_testimonialtrack",
  "testimonialtrackinner": "Sd-1Jq_testimonialtrackinner",
  "wrapper": "Sd-1Jq_wrapper",
});
